import { FormattedMessage } from 'react-intl'
import { Grid } from '@mui/material'
import { WorkflowDemo } from 'features/workflows/types'
import WorkflowCard from 'features/workflows/ui/Gallery/WorkflowCard'
import { useOpenDemoWorkflow } from 'features/workflows/hooks/demoWorkflows'
import { useAppSelector } from 'app/state'

export function HomeDemoWorkflows({ workflows }: { workflows?: WorkflowDemo[] }) {
  const creatingDemoWorkflowsIds = useAppSelector((state) => state.workflows.creatingDemoWorkflowsIds)
  const openDemoWorkflow = useOpenDemoWorkflow()

  return (
    <>
      {workflows?.map((demo) => {
        return (
          <Grid item xs={12} sm={6} md={4} lg={3} key={demo.workflow.id}>
            <WorkflowCard
              workflow={demo.workflow}
              loading={(demo.workflow.id && creatingDemoWorkflowsIds.includes(demo.workflow.id)) || false}
              loadingMessage={<FormattedMessage id="workflows.creatingDemoWorkflow" />}
              onClick={() => openDemoWorkflow(demo)}
              demo={demo}
            />
          </Grid>
        )
      })}
    </>
  )
}

export default HomeDemoWorkflows
